import wx from "weixin-js-sdk";
import * as ww from "@wecom/jssdk";
import {
  getConfigTicket,
  getConfigGetSignature,
  getTicket,
} from "@/api/wxcgibin";

console.log(wx);
console.log(ww);

const jsApiList = [
  "invoke",
  "checkJsApi",
  "getContext",
  "selectEnterpriseContact",
  "openUserProfile",
  "openEnterpriseChat",
  "onMenuShareAppMessage",
  "onMenuShareWechat",
  "onMenuShareTimeline",
  "shareAppMessage",
  "shareWechatMessage",
  "onHistoryBack",
  "hideOptionMenu",
  "showOptionMenu",
  "closeWindow",
  "hideMenuItems",
  "showMenuItems",
  "hideAllNonBaseMenuItem",
  "showAllNonBaseMenuItem",
  "openDefaultBrowser",
  "onUserCaptureScreen",
  "scanQRCode",
  "enterpriseVerify",
  "openAppManage",
  "chooseImage",
  "previewImage",
  "uploadImage",
  "downloadImage",
  "getLocalImgData",
  "startRecord",
  "stopRecord",
  "playVoice",
  "pauseVoice",
  "stopVoice",
  "uploadVoice",
  "downloadVoice",
  "translateVoice",
  "createWWLoginPanel",
  "previewFile",
  "setClipboardData",
  "getClipboardData",
  "getNetworkType",
  "onNetworkStatusChange",
  "openLocation",
  "getLocation",
  "startAutoLBS",
  "stopAutoLBS",
  "onLocationChange",
  "selectExternalContact",
  "shareToExternalContact",
  "shareToExternalChat",
  "navigateToAddCustomer",
  "shareToExternalMoments",
  "updateMomentsSetting",
  "checkSchedule",
  "startMeeting",
  "startLiving",
  "replayLiving",
  "downloadLivingReplay",
  "thirdPartyOpenPage",
];

export const handleWxConfig = async () => {
  // initWwSdk();
  initWxSdk();
};

// 初始化企业微信SDK
const initWwSdk = async () => {
  try {
    getConfigTicket().then((res1: any) => {
      const jsapiTicket = res1.data;
      getConfigGetSignature({
        url: window.location.href.split("#")[0],
        jsapiTicket,
      }).then(async (res) => {
        let { noncestr, signature, timestamp } = JSON.parse(res.data);
        wx.config({
          debug: false,
          beta: false,
          appId: import.meta.env.VITE_WX_APPID,
          timestamp: timestamp,
          nonceStr: noncestr,
          signature: signature,
          jsApiList: ["checkJsApi", "showOptionMenu"],
        });

        // 5. 验证配置是否成功
        wx.ready(() => {
          wx.checkJsApi({
            jsApiList: ["showOptionMenu"],
            success: (res) => {
              console.log(res);
            },
            fail: (err) => {
              console.log(err);
            },
          });

          wx.showOptionMenu();
        });

        wx.error((err: any) => {
          console.log(err, "SDK初始化失败");
        });
      });
    });
  } catch (err) {}
};

const initWxSdk = async () => {
  const jsapiTicket = await getTicket();
  if (jsapiTicket.code != "200") return false;
  ww.register({
    corpId: import.meta.env.VITE_WX_APPID, // 必填，当前用户企业所属企业ID
    agentId: import.meta.env.VITE_AGENt_ID,
    jsApiList: jsApiList,
    getConfigSignature: async (url) => {
      const res = await getConfigGetSignature({
        url: url,
        jsapiTicket: jsapiTicket.data,
      });
      let { noncestr, signature, timestamp } = JSON.parse(res.data);
      return { timestamp, nonceStr: noncestr, signature };
    },
    onConfigSuccess: (result) => {},
    onConfigFail: (err) => {},
    getAgentConfigSignature: async (url) => {
      const res = await getConfigGetSignature({
        url: url,
        jsapiTicket: jsapiTicket.data,
      });
      let { noncestr, signature, timestamp } = JSON.parse(res.data);
      return { timestamp, nonceStr: noncestr, signature };
    },
    onAgentConfigSuccess: (result) => {
      ww.checkJsApi({
        jsApiList: jsApiList,
        success: (res) => {
          console.log(res);
        },
        fail: (err) => {
          console.log(err);
        },
      });
      ww.hideOptionMenu();
      ww.hideAllNonBaseMenuItem();
      if (typeof window.onAgentConfigSuccess === "function") {
        window.onAgentConfigSuccess();
      }
    },
    onAgentConfigFail: (err) => {},
  });
};

export const createWWLoginPanel = () => {
  return new Promise((resolve) => {
    ww.createWWLoginPanel({
      el: "#login",
      params: {
        login_type: "CorpApp",
        appid: import.meta.env.VITE_WX_APPID,
        agentid: import.meta.env.VITE_AGENt_ID,
        redirect_uri: window.location.origin,
        state: "loginState",
        redirect_type: "callback",
        panel_size: "small",
      },
      onLoginSuccess({ code }) {
        resolve(code);
      },
    });
  });
};
